export default "__VITE_ASSET__2edec77b__"